import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/recipes.selectors';
import { FacadeService } from '../facade.service';

@Injectable({
  providedIn: 'root',
})
export class RecipesLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  recipeType$ = this.storeSelect(selectors.getRecipeType);
  schema$ = this.storeSelect(selectors.getSchema);
  country$ = this.storeSelect(selectors.getCountry);
  pointSource$ = this.storeSelect(selectors.getPointSource);
  deleted$ = this.storeSelect(selectors.getDeleted);
  active$ = this.storeSelect(selectors.getActive);
  startDate$ = this.storeSelect(selectors.getStartDate);
  endDate$ = this.storeSelect(selectors.getEndDate);
  updateRecipeInfo$ = this.storeSelect(selectors.getUpdateRecipeInfo);
  getId$ = this.storeSelect(selectors.getId);
  getCreationDate$ = this.storeSelect(selectors.getCreationDate);
  getChangeDate$ = this.storeSelect(selectors.getChangeDate);

  memberCategory$ = this.storeSelect(selectors.getMemberCategory);
  memberTag$ = this.storeSelect(selectors.getMemberTag);
  daysOfWeek$ = this.storeSelect(selectors.getDaysOfWeek);
  description$ = this.storeSelect(selectors.getDescription);

  // OBSERVABLE'S VALUES

  get getId() {
    return this.storeSnapshot(this.getId$);
  }
  get getCreationDate() {
    return this.storeSnapshot(this.getCreationDate$);
  }
  get getChangeDate() {
    return this.storeSnapshot(this.getChangeDate$);
  }
}
